import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {EmpionButton} from '../../../components/EmpionButton/EmpionButton';
import {useTrackingEvents} from '../../../hooks/useTrackingEvents';
import {orangeColors, neutral} from '../../../layouts/theme/designSystem';
import {TrackingEvents} from '../../../types/TrackingEvents';

const heroPreviewImageUrl = '/assets/laptop_transparent.png';

export const HeroContainer = ({handleCtaClick}: {handleCtaClick: () => void}) => {
  const {t} = useTranslation();
  const {eventAttributes} = useTrackingEvents({
    version: TrackingEvents.Version.v1,
    category: TrackingEvents.Category.Marketing,
    action: TrackingEvents.Action.B2BSimplifiedCultureQuestionnaireStarted,
    payload: {
      page: 'b2b_marketing',
      section: 'hero',
    },
  });

  return (
    <Grid
      id='home'
      width='100%'
      sx={{
        background: 'white',
        pt: {xs: 3, md: 5},
        pb: {xs: 4, md: 7},
        px: {xs: 2, sm: 3},
        minHeight: {md: '586px'},
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: {xs: 'column', md: 'row'},
          gap: {xs: 4, md: 5},
          alignItems: 'stretch',
        }}
      >
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1}}>
          <Typography
            sx={{
              color: neutral['primary-black'],
              fontWeight: 700,
              fontSize: {xs: '2.5rem', sm: '3rem', md: '4rem'},
              lineHeight: 1.15,
              maxWidth: '462px',
            }}
          >
            {t('b2b.hero.headlineFirstLine')}
            <br />
            <Box component='span' sx={{color: orangeColors[900]}}>
              {t('b2b.hero.headlineHighlight')}
            </Box>
            <br />
            {t('b2b.hero.headlineLastLine')}
          </Typography>

          <EmpionButton
            onClick={handleCtaClick}
            {...eventAttributes}
            sx={{
              mt: {xs: 4, md: 8},
              px: 3,
              py: 1.25,
              width: {xs: '100%', sm: 'auto'},
              maxWidth: '432px',
              minHeight: '70px',
              backgroundColor: orangeColors[900],
              '&:hover': {
                backgroundColor: orangeColors[950],
              },
            }}
          >
            <Typography
              component='span'
              sx={{
                color: '#ffffff',
                fontSize: {xs: '1.25rem', sm: '1.5rem'},
                fontWeight: 700,
                lineHeight: 1.5,
                textAlign: 'center',
              }}
            >
              {t('b2b.hero.ctaButton')}
            </Typography>
          </EmpionButton>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: {xs: '300px', md: '540px'},
            borderRadius: '5px',
            backgroundColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: {xs: '460px', md: '560px'},
              height: 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={heroPreviewImageUrl}
              alt={t('b2b.hero.imageAlt')}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};
